import type { Fact } from "@/lib/posting";

/** What the posting states, and where the person's application stands. */
export default function FactsCard({ facts }: { facts: readonly Fact[] }) {
    return (
        <section className="flex flex-col gap-1 rounded-card border border-line bg-card p-5 shadow-card">
            <h2 className="m-0 mb-2 font-display text-card-title font-bold tracking-[-0.01em]">
                Facts
            </h2>
            <dl className="m-0 grid grid-cols-[110px_minmax(0,1fr)] gap-x-3 gap-y-2 text-ui">
                {facts.map((fact) => (
                    <div key={fact.label} className="contents">
                        <dt className="text-fg-muted">{fact.label}</dt>
                        <dd className={`m-0 ${fact.mono ? "break-all font-mono text-small" : ""}`}>
                            {fact.value}
                        </dd>
                    </div>
                ))}
            </dl>
        </section>
    );
}
